import { FC, useCallback } from "react";
import { FormControlLabel, Stack, Switch } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { toggleShowBudgetLine } from "@/store/resource-explorer/resourceExplorerSlice";
import { resourceExplorerShowBudgetLineSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/data/resourceExplorerShowBudgetLineSelector";
import { resourceExplorerViewCurrentBudgetSelector } from "@/store/resource-explorer/selectors/budget/resourceExplorerViewCurrentBudgetSelector";

export const BillingExplorerShowBudgetLineSettingSwitcher: FC = () => {
  const dispatch = useAppDispatch();

  const showBudgetLine = !!useAppSelector(
    resourceExplorerShowBudgetLineSelector,
  );

  const budget = !!useAppSelector(resourceExplorerViewCurrentBudgetSelector);

  const changeHandler = useCallback(() => {
    dispatch(toggleShowBudgetLine());
  }, [dispatch]);

  if (!budget) {
    return null;
  }

  return (
    <Stack pl={1} mt={1.5} direction="row" alignItems="center">
      <FormControlLabel
        onChange={changeHandler}
        checked={showBudgetLine}
        sx={{ width: "fit-content" }}
        control={<Switch size="small" />}
        label={<Typography variant="body2">Show Budget Line</Typography>}
      />
    </Stack>
  );
};
